import React from 'react'
import EmployeeForm, { EmployeeFormData } from './EmployeeForm';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useUpdateResource } from '../../../hooks/useUpdateResource';
import { useRolesByAdmin } from '../../../hooks/admin/roles.admin';
import LoadingButton from '../../form/LoadingButton';
import SubmitButton from '../../form/SubmitButton';
import LoadingErrorState from '../../ui/LoadingErrorState';


interface UpdateEmployeeFormProps {
  id: number;
  defaultValues: EmployeeFormData;
  onSubmitSuccess:()=>void
}

function UpdateEmployeeFormWrapper({id,defaultValues,onSubmitSuccess}:UpdateEmployeeFormProps) {
     const { register, handleSubmit, formState: { errors } , setValue ,watch} = useForm<EmployeeFormData>();
    
        const {t} = useTranslation();
    
       const { loading, updateResource } = useUpdateResource();
       const {data:roles , isError , isLoading} = useRolesByAdmin(false);
      
        const onSubmit = async(data: EmployeeFormData) => {
          await updateResource(`admin/${id}`, {phone:`966${data.phone}`,name:data.name, roleId:+data.roleId},
              "admin",{
                  method: "PUT",
                  successMessage: t("updatedSuccess"),
                  invalidateQueries:["employees-by-admin"],
                });
            onSubmitSuccess();
        };
  return (
    <div className='p-4'>
        <LoadingErrorState
      isError={isError}
      isLoading={isLoading}
      />
      <form onSubmit={handleSubmit(onSubmit)}  className="flex flex-col gap-4 w-full">
        {
            roles &&
            <>
                <EmployeeForm register={register} errors={errors} setValue={setValue} watch={watch} roles={roles} defaultValues={{...defaultValues,phone:defaultValues.phone.slice(3)}}/>
                {
                    loading
                    ?
                    <LoadingButton/>
                    :
                    <SubmitButton label="update"/>
                } 
            </>
        }
      </form>
    </div>
  )
}

export default UpdateEmployeeFormWrapper